import React, { memo, useCallback, useEffect, useState } from 'react';
import { Button, DiamondPlusIcon, Icon, Image, Link, Loading } from '@/components';
import { useStickerQuery } from '../../../api';
import { CollectionStickerType, StickerType } from '../../../const';
import { useMasterData } from '@/contexts/profile';
import { toMoney } from '@/libs/app';
import { TFunction } from 'next-i18next';
import { useRouter } from 'next/router';
import { PagePath } from '@/layouts/shared';

type SendStickerProps = {
  collectionStickers: CollectionStickerType[];
  sendSticker: (sticker: StickerType) => void;
  giftAtd: (amount: number) => void;
  t: TFunction;
  isLoading: boolean;
};
const SendSticker = ({ collectionStickers, sendSticker, t, giftAtd, isLoading }: SendStickerProps) => {
  const router = useRouter();
  const [collection, setCollection] = useState<string>(collectionStickers[0].name);
  const [listSticker, setListSticker] = useState<StickerType[]>([]);
  const masterData = useMasterData();
  const [sticker, setSticker] = useState<StickerType>();
  const [atd, setAtd] = useState<number>(0);
  const { refetch: refetchSticker, isLoading: isLoadingStickers } = useStickerQuery(
    {
      collection: collection != 'send-atd' ? collection : collectionStickers[0].name,
      offset: 0,
      limit: 100,
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setListSticker(data.data);
      },
    }
  );

  const chooseSticker = useCallback(() => {
    if (atd && collection === 'send-atd') return giftAtd(atd);
    const collectionStickerId = collectionStickers.find((c) => c.name === collection)?.id;

    if (sticker && collectionStickerId) {
      const _s = {
        id: sticker.id,
        icon: sticker.icon,
        name: sticker.name,
        collection_id: collectionStickerId,
      };
      return sendSticker(_s);
    }
  }, [atd, collection, giftAtd, sendSticker, sticker, collectionStickers]);

  useEffect(() => {
    if (collection != 'send-atd') refetchSticker();
  }, [collection, refetchSticker]);

  return (
    <>
      <div className="tw-px-4">
        <div className="tw-flex tw-items-center tw-w-11/12 tw-overflow-x-auto">
          {collectionStickers.map((c) => (
            <div
              className={`tw-pr-6 tw-text-secondary-70 tw-cursor-pointer ${
                collection === c.name ? 'tw-font-semibold' : ''
              }`}
              onClick={() => setCollection(c.name)}
              key={'sticker-' + c.id}
            >
              {c.name}
            </div>
          ))}
          <div
            className={`tw-pr-6 tw-text-secondary-70 tw-cursor-pointer ${
              collection === 'send-atd' ? 'tw-font-semibold' : ''
            }`}
            onClick={() => setCollection('send-atd')}
            key={'send-atd'}
          >
            {masterData?.live_stream_gift_atd?.title}
          </div>
        </div>
        <div className="tw-h-28 tw-mt-4 tw-leading-0 tw-justify-start tw-items-start tw-overflow-y-auto tw-flex tw-flex-wrap tw-relative ">
          {isLoadingStickers ? (
            <div className="tw-col-span-5 tw-flex tw-items-center tw-justify-center tw-w-full">
              <Loading />
            </div>
          ) : (
            <>
              {collection === 'send-atd' && (
                <div>
                  <div className="tw-text-sm">{masterData?.live_stream_gift_atd?.description}.</div>
                  {/* <div className="tw-text-sm tw-font-semibold">
                  Mỗi <span className="tw-text-primary-main">ATD</span> tương đương{' '}
                  <span className="tw-text-warning-90">100,000 đ</span>
                </div> */}
                  <div className="tw-mt-3 tw-grid tw-grid-cols-3 tw-gap-3">
                    {masterData?.live_stream_gift_atd?.amounts.map((price: number) => (
                      <>
                        <div
                          className={`tw-cursor-pointer tw-relative tw-flex tw-items-center tw-border tw-rounded-5 tw-overflow-hidden before:tw-w-[5px] before:tw-h-full before:tw-bg-primary-main before:tw-absolute before:tw-left-0 before:tw-top-0 tw-p-2 ${
                            atd === price ? 'tw-bg-[#EFFDFA] tw-border-primary-main' : 'tw-bg-white tw-border-[#9E9E9E]'
                          }`}
                          key={`amount-${price}`}
                          onClick={() => setAtd(price)}
                        >
                          <Image src="/diamond-kam.png" alt="diamond" className="tw-w-5 tw-h-5 tw-mr-1" />
                          <div className="tw-flex tw-flex-col">
                            <span className="tw-font-bold tw-text-xs tw-text-primary-main">{price} ATD ~</span>
                            <span className="tw-font-bold tw-text-xs tw-text-warning-90">
                              {toMoney(price * 100000, t)}
                            </span>
                          </div>
                        </div>
                      </>
                    ))}
                    <Link
                      className={`tw-cursor-pointer tw-relative tw-flex tw-items-center tw-border tw-border-primary-main tw-rounded-5 tw-overflow-hidden before:tw-w-[5px] before:tw-h-full before:tw-bg-primary-main before:tw-absolute before:tw-left-0 before:tw-top-0 tw-p-2 tw-bg-primary-main`}
                      key={`deposit-atd`}
                      url={PagePath.AccountDepositPage}
                      target="_blank"
                    >
                      <Icon icon={<DiamondPlusIcon />} className="tw-w-5 tw-h-5 tw-text-white" />
                      <div className="tw-flex tw-flex-col tw-text-white">Nạp ATD</div>
                    </Link>
                  </div>
                </div>
              )}
              {collection != 'send-atd' &&
                listSticker.map((s) => (
                  <div
                    className={`tw-relative tw-mr-3 tw-mb-3 tw-rounded-5 tw-cursor-pointer ${
                      sticker?.id == s.id ? 'tw-border tw-border-primary-main' : ''
                    }`}
                    key={`sticker-${s.name}`}
                    onClick={() => setSticker(s)}
                  >
                    <Image
                      alt={s.name}
                      src={s.icon}
                      className="tw-w-10 tw-h-10 xl:tw-w-14 xl:tw-h-14"
                      objectFit="cover"
                    ></Image>
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
      <div className="tw-flex tw-justify-end tw-pt-2 tw-px-4 tw-bg-white tw-relative tw-z-1">
        <Button
          className="tw-text-white tw-text-13 tw-bg-primary-main tw-px-4 tw-py-1 tw-uppercase !tw-w-auto !tw-rounded-5"
          onClick={() => chooseSticker()}
          loading={isLoading}
        >
          Gửi tặng
        </Button>
      </div>
    </>
  );
};

export default memo(SendSticker);
